var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChipExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.93909 7.99943L11.803 5.14179C12.0642 4.88059 12.0642 4.4571 11.803 4.1959C11.5418 3.9347 11.1184 3.9347 10.8572 4.1959L8 7.06021L5.14276 4.1959C4.8816 3.9347 4.45817 3.9347 4.19701 4.1959C3.93585 4.4571 3.93585 4.88059 4.19701 5.14179L7.06091 7.99943L4.19701 10.8571C4.07092 10.9822 4 11.1524 4 11.33C4 11.5076 4.07092 11.6779 4.19701 11.803C4.32207 11.9291 4.4923 12 4.66988 12C4.84747 12 5.0177 11.9291 5.14276 11.803L8 8.93866L10.8572 11.803C10.9823 11.9291 11.1525 12 11.3301 12C11.5077 12 11.6779 11.9291 11.803 11.803C11.9291 11.6779 12 11.5076 12 11.33C12 11.1524 11.9291 10.9822 11.803 10.8571L8.93909 7.99943Z",
    fill: "#D1E4F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipExit);
export default __webpack_public_path__ + "static/media/chip-exit.baabe55d2b71207cef03a48af45b962b.svg";
export { ForwardRef as ReactComponent };